import React from 'react';
import PhoneInput from './PhoneInput';
import {
  Box,
  TextField,
  // FormControl,
  // InputLabel,
  // Select,
  // MenuItem,
  FormControlLabel,
  Checkbox,
  Typography
} from '@mui/material';

const AdditionalInfoForm = ({ additional, onChange, countryCodes }) => {

let expectedLength = localStorage.getItem('expectedLength');
  
return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      <TextField
        label="Email"
        name="email"
        type="email"
        value={additional.email}
        onChange={onChange}
        required
        fullWidth
        onInvalid={e => e.target.setCustomValidity('Please enter a valid email')}
        onInput={e => e.target.setCustomValidity('')}
      />

      <PhoneInput
        codeName="mobileCode"
        numberName="mobile"
        codeValue={additional.mobileCode}
        numberValue={additional.mobile}
        onChange={onChange}
        countryCodes={countryCodes}
      />

      <TextField
        label="Contact Person Name"
        name="contactName"
        value={additional.contactName}
        onChange={onChange}
        required
        fullWidth
      />

      <TextField
        label="Contact Person Designation"
        name="contactDesignation"
        value={additional.contactDesignation}
        onChange={onChange}
        fullWidth
      />

      <TextField
        label="Contact Person Department"
        name="contactDepartment"
        value={additional.contactDepartment}
        onChange={onChange}
        fullWidth
      />

      {/* <Box sx={{ display: 'flex', gap: 1 }}>
        <FormControl sx={{ width: 120 }}>
          <InputLabel>Code</InputLabel>
          <Select
            label="Code"
            name="contactMobileCode"
            value={additional.contactMobileCode}
            onChange={onChange}
            required
          >
            {countryCodes.map(c => (
              <MenuItem key={c.code} value={c.code}>
                {c.label} ({c.code})
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <TextField
          label="Contact Person Mobile"
          name="contactMobile"
          value={additional.contactMobile}
          onChange={onChange}
          required
          fullWidth
          inputProps={{ pattern: '^[0-9]{10}$', title: '10 digits' }}
          helperText="10 digits"
          onInvalid={e => e.target.setCustomValidity('Please enter a 10-digit phone number')}
          onInput={e => e.target.setCustomValidity('')}
        />
      </Box> */}

      <TextField
        label="Authorised Signatory Name"
        name="authorisedSignatoryName"
        value={additional.authorisedSignatoryName}
        onChange={onChange}
        required
        fullWidth
      />

      <TextField
        label="Authorised Signatory Mobile Number"
        name="authorisedSignatoryMobile"
        value={additional.authorisedSignatoryMobile}
        onChange={onChange}
        required
        fullWidth
        inputProps={{ pattern: `^[0-9]{${expectedLength}}$`, title: `${expectedLength} digits` }}
        helperText={`${expectedLength} digits`}
        onInvalid={e => e.target.setCustomValidity(`Please enter a ${expectedLength}-digit phone number`)}
        onInput={e => e.target.setCustomValidity('')}
      />

      <TextField
        label="Authorised Signatory Email ID"
        name="authorisedSignatoryEmail"
        type="email"
        value={additional.authorisedSignatoryEmail}
        onChange={onChange}
        required
        fullWidth
        onInvalid={e => e.target.setCustomValidity('Please enter a valid email')}
        onInput={e => e.target.setCustomValidity('')}
      />

      <TextField
        label="Authorised Signatory Designation"
        name="authorisedSignatoryDesignation"
        type="text"
        onChange={onChange}
        value={additional.authorisedSignatoryDesignation}
        required
        fullWidth
      />

      <FormControlLabel
        control={
          <Checkbox
            name="certifyTrue"
            checked={additional.certifyTrue}
            onChange={onChange}
            required
          />
        }
        label="We certify that the above details are true and correct and are supported by documentary evidence which shall be produced on request. we shall update you at the earliest in the event of any change in our status irrespective of it being on account of any reorganisation."
        sx={{
          '& .MuiFormControlLabel-label': {
            fontSize: '12px',
            fontStyle: 'italic',
            fontWeight: '600',
            lineHeight: '0',
            textTransform: 'none',
          },
        }}
      />

      <FormControlLabel
        control={
          <Checkbox
            name="acceptPrivacy"
            checked={additional.acceptPrivacy}
            onChange={onChange}
            required
          />
        }
      label={
        <Typography
          variant="body2"
          sx={{
                fontSize: '12px',
                fontStyle: 'italic',
                fontWeight: '600',
                lineHeight: '2',
                textTransform: 'none',
          }}
        >
          I/we hereby confirm that I/we have fully read, understood and agree to be bound by the terms and conditions contained in the data privacy policy available on the website - &nbsp;
          <a
            href="https://www.ril.com/Privacy-Policy.aspx"
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: '#1976d2', textDecoration: 'underline' }}
          >
            www.ril.com/Privacy-Policy.aspx 
          </a>
           &nbsp; as applicable to the visitors.
    </Typography>
  }
/>

    </Box>
  );
};

export default AdditionalInfoForm;